module.exports = __webpack_public_path__ + "img/p-two-step-11.96bda64d.png";